import { setPassword, setRoomPasswordPrejoin, setStartMutedAudioPolicy, setStartMutedVideoPolicy, setStartReactionsMuted } from '../base/conference/actions.web';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { getLocalParticipant, pinParticipant } from '../base/participants';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { updateSettings } from '../base/settings/actions';
import { addStageParticipant, removeStageParticipant, setFilmstripVisible, setIsPaging } from '../filmstrip/actions.web';
import { setTileView } from '../video-layout/actions.any';
import { COMMANDS } from './constants';
import { addCommand, removeCommand } from './slice';
import { hideNotification, showNotification } from '../notifications/actions.web';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { localParticipantApproved } from '../av-moderation/actions';
import { ASKED_TO_UNMUTE_NOTIFICATION_ID, ASKED_TO_UNMUTE_SOUND_ID } from '../av-moderation/constants';
import { MEDIA_TYPE } from '../base/media/constants';
import { playSound } from '../base/sounds/actions';
import { LANDING_PAGE } from '../../../modules/API/constants_ts';
import { muteLocal } from '../video-menu/actions.any';
import { sendChangeName } from './functions';
import { checkIsJibri, checkSipGateway } from '../app/functions.any';
import { activeLockRoom, unActiveLockRoom } from '../base/test/slice';
import './middleware.any';
// import i18n from "i18next";
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the A/V moderation feature to operate.
 */
StateListenerRegistry.register((state) => state["features/base/conference"].conference, (conference, { getState, dispatch }, previousConference) => {
    if (conference && !previousConference) {
        conference.on(JitsiConferenceEvents.MOD_COMMAND_EMIT, ({ commandObj }) => {
            dispatch(addCommand(commandObj));
            switch (true) {
                case COMMANDS.PIN_PARTICIPANT.COMMAND === commandObj.command: {
                    const participantId = `${commandObj.value}`;
                    dispatch(pinParticipant(participantId));
                    // const pinnedParticipants = getPinnedActiveParticipants(getState());
                    // if(!pinnedParticipants.find(p => p.participantId === participantId)){
                    //     dispatch(togglePinStageParticipant(participantId));
                    // }
                    dispatch(addStageParticipant(participantId, true));
                    dispatch(removeCommand(COMMANDS.UN_PIN_PARTICIPANT.COMMAND));
                    break;
                }
                case COMMANDS.UN_PIN_PARTICIPANT.COMMAND === commandObj.command: {
                    dispatch(pinParticipant(""));
                    dispatch(removeStageParticipant(`${commandObj.value}`));
                    dispatch(removeCommand(COMMANDS.PIN_PARTICIPANT.COMMAND));
                    break;
                }
                case COMMANDS.SET_PASSWORD.COMMAND === commandObj.command: {
                    dispatch(setRoomPasswordPrejoin(`${commandObj.value}`));
                    dispatch(setPassword(conference, conference?.lock, `${commandObj.value}`));
                    break;
                }
                case COMMANDS.STAGE_VIEW.COMMAND === commandObj.command: {
                    dispatch(setTileView(false));
                    dispatch(setFilmstripVisible(commandObj.value === COMMANDS.STAGE_VIEW.FILM_STRIP_ON));
                    break;
                }
                case COMMANDS.STAGE_VIEW.COMMAND === commandObj.command: {
                    dispatch(setTileView(false));
                    dispatch(setFilmstripVisible(commandObj.value === COMMANDS.STAGE_VIEW.FILM_STRIP_ON));
                    break;
                }
                case COMMANDS.GRID_VIEW.COMMAND === commandObj.command: {
                    dispatch(setTileView(true));
                    if (checkIsJibri()) {
                        dispatch(setIsPaging(true));
                    }
                    dispatch(setFilmstripVisible(false));
                    break;
                }
                case COMMANDS.HANDLE_CHANGE_START_AUDIO_MUTED.COMMANDS === commandObj.command: {
                    let convertString = commandObj.value?.toString();
                    let value = JSON.parse(convertString || "");
                    APP.store.dispatch(setStartMutedAudioPolicy(!value?.startAudioMutedState, value?.startVideoMutedState));
                    break;
                }
                case COMMANDS.HANDLE_CHANGE_START_VIDEO_MUTED.COMMANDS === commandObj.command: {
                    let convertString = commandObj.value?.toString();
                    let value = JSON.parse(convertString || "");
                    APP.store.dispatch(setStartMutedVideoPolicy(!value?.startVideoMutedState, value?.startAudioMutedState));
                    break;
                }
                case COMMANDS.HANDLE_CHANGE_START_REACTIONS_MUTED.COMMANDS === commandObj.command: {
                    let value = commandObj.value === "true" ? true : false;
                    APP.store.dispatch(setStartReactionsMuted(!(value), true));
                    APP.store.dispatch(updateSettings({ soundsReactions: !!(value) }));
                    break;
                }
                case COMMANDS.CHANGE_VIEW.COMMANDS === commandObj.command: {
                    if (commandObj.value === COMMANDS.CHANGE_VIEW.MAIN_SPEAKER) {
                        dispatch(setTileView(false));
                        dispatch(setFilmstripVisible(true));
                    }
                    else if (commandObj.value === COMMANDS.CHANGE_VIEW.FOCUS) {
                        dispatch(setTileView(false));
                        dispatch(setFilmstripVisible(false));
                    }
                    else if (commandObj.value === COMMANDS.CHANGE_VIEW.TILE) {
                        dispatch(setTileView(true));
                        dispatch(setFilmstripVisible(false));
                    }
                    break;
                }
                //Cập nhật trạng thái cho người bị cấm micro được phép bật micro
                case COMMANDS.LOCAL_AUDIO_PARTICIPANT_APPROVED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        dispatch(localParticipantApproved(MEDIA_TYPE.AUDIO));
                        dispatch(showNotification({
                            titleKey: 'notify.allowTurnOnMicro',
                            sticky: true,
                            customActionNameKey: ['notify.action.close', 'notify.action.turnOnMicro'],
                            customActionHandler: [() => dispatch(hideNotification(ASKED_TO_UNMUTE_NOTIFICATION_ID)), () => dispatch(muteLocal(false, MEDIA_TYPE.AUDIO))],
                            uid: ASKED_TO_UNMUTE_NOTIFICATION_ID
                        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                        dispatch(playSound(ASKED_TO_UNMUTE_SOUND_ID));
                    }
                    break;
                }
                //Cập nhật trạng thái cho người bị cấm camera được phép bật camera
                case COMMANDS.LOCAL_VIDEO_PARTICIPANT_APPROVED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        dispatch(localParticipantApproved(MEDIA_TYPE.VIDEO));
                        dispatch(showNotification({
                            titleKey: 'notify.allowTurnOnVideo',
                            sticky: true,
                            customActionNameKey: ['notify.action.close', 'notify.action.turnOnCamera'],
                            customActionHandler: [() => dispatch(hideNotification(ASKED_TO_UNMUTE_NOTIFICATION_ID)), () => dispatch(muteLocal(false, MEDIA_TYPE.VIDEO))],
                            uid: ASKED_TO_UNMUTE_NOTIFICATION_ID
                        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                        dispatch(playSound(ASKED_TO_UNMUTE_SOUND_ID));
                    }
                    break;
                }
                case COMMANDS.CHANGE_NAME.COMMAND === commandObj.command: {
                    const objValue = typeof commandObj.value === 'string' ? JSON.parse(commandObj.value) : null;
                    const idTabCurrent = APP.conference.getMyUserId();
                    if (objValue?.id === idTabCurrent) {
                        sendChangeName(objValue);
                    }
                    break;
                }
                case COMMANDS.KICK_REMOTE_PARTICIPANT.COMMAND === commandObj.command: {
                    const idKicked = commandObj.value;
                    const idTabCurrent = APP.conference.getMyUserId();
                    if (idKicked === idTabCurrent) {
                        dispatch(showNotification({
                            titleKey: 'notify.kickRemoteParticipant',
                        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                        setTimeout(() => {
                            window.location.href = `${LANDING_PAGE}`;
                        }, 3000);
                    }
                    break;
                }
                case COMMANDS.MUTE_PARTICIPANT.COMMAND === commandObj.command: {
                    const idParticipant = commandObj.value;
                    const idTabCurrent = APP.conference.getMyUserId();
                    if (idParticipant === idTabCurrent) {
                        dispatch(muteLocal(true, MEDIA_TYPE.AUDIO, false));
                        dispatch(showNotification({
                            titleKey: 'notify.mutedParticipantTitle',
                        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                    }
                    break;
                }
                case COMMANDS.MUTE_VIDEO_PARTICIPANT.COMMAND === commandObj.command: {
                    const idParticipant = commandObj.value;
                    const idTabCurrent = APP.conference.getMyUserId();
                    if (idParticipant === idTabCurrent) {
                        dispatch(muteLocal(true, MEDIA_TYPE.VIDEO, false));
                        dispatch(showNotification({
                            titleKey: 'notify.mutedVideoParticipantTitle',
                        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                    }
                    break;
                }
                case COMMANDS.MIC_SIP.COMMAND === commandObj.command && checkSipGateway(): {
                    if (COMMANDS.MIC_SIP.ON === commandObj.value) {
                        dispatch(muteLocal(false, MEDIA_TYPE.AUDIO));
                    }
                    else if (COMMANDS.MIC_SIP.OFF === commandObj.value) {
                        dispatch(muteLocal(true, MEDIA_TYPE.AUDIO));
                    }
                    break;
                }
                case COMMANDS.CAM_SIP.COMMAND === commandObj.command && checkSipGateway(): {
                    if (COMMANDS.CAM_SIP.ON === commandObj.value) {
                        dispatch(muteLocal(false, MEDIA_TYPE.VIDEO));
                    }
                    else if (COMMANDS.CAM_SIP.OFF === commandObj.value) {
                        dispatch(muteLocal(true, MEDIA_TYPE.VIDEO));
                    }
                    break;
                }
                case COMMANDS.LOCK.COMMAND === commandObj.command: {
                    if (COMMANDS.LOCK.ON === commandObj.value) {
                        dispatch(activeLockRoom());
                    }
                    else if (COMMANDS.LOCK.OFF === commandObj.value) {
                        dispatch(unActiveLockRoom());
                    }
                    break;
                }
                default: {
                    console.log(`Command ${commandObj.command} is not supported`);
                }
            }
        });
    }
});
